'use strict';
const angular = require('angular');
const {isString, isUndefined} = angular;

export function DomainCacheProvider() {
  this.$get = [
    '$log',
    '$cacheFactory',
    '$domain',
    function (
      $log,
      $cacheFactory,
      $domain,
    ) {
      return {
        get: function (collection, id) {
          if (!collection || !isString(collection)) {
            throw new Error('$domainCache Error: you must specify a collection to retrieve its domain class!');
          } else if (!id || !isString(id)) {
            throw new Error('$domainCache Error: you must specify an id to retrieve!');
          } else {
            if (isUndefined($domain.getDomain(collection))) {
              throw new Error('$domainCache Error: could not find a domain class registered for collection ' + collection);
            } else {
              return ($cacheFactory.get(collection) || $cacheFactory(collection)).get(id) || null;
            }
          }
        },
        put: function (collection, id, instance) {
          if (!collection || !isString(collection)) {
            throw new Error('$domainCache Error: you must provide a collection to register a domain class to!');
          } else if (!id || !isString(id)) {
            throw new Error('$domainCache Error: you must provide an id to cache!');
          } else {
            ($cacheFactory.get(collection) || $cacheFactory(collection)).put(id, instance);
          }
        },
        remove: function (collection, id) {
          if (!collection || !isString(collection)) {
            throw new Error('$domainCache Error: you must provide a collection to retrieve its domain class!');
          } else if (!id || !isString(id)) {
            throw new Error('$domainCache Error: you must specify an id to remove!');
          } else {
            $log.debug('$domainCache.remove: removing id "' + id + '" from the "' + collection + '" collection cache.');
            ($cacheFactory.get(collection) || $cacheFactory(collection)).remove(id);
          }
        }
      }
    }]
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainCache.js